import React, { Component } from 'react';
import config from 'react-global-configuration';

config.set({
	url: 'https://stagingportal.sigvoos.com.br',
	auth: 'https://stagingapi.sigvoos.com.br',
	api: 'https://stagingapi.sigvoos.com.br/api',
	cdn: 'https://stagingcdn.sigvoos.com.br',
	api_sigmec: 'https://stagingapi.sigvoos.com.br/api',
	cdn_sigmec: 'https://stagingcdn.sigvoos.com.br',
	api_sigtrein: 'https://stagingapi.sigvoos.com.br/api',
	cdn_sigtrein: 'https://stagingcdn.sigvoos.com.br',
	development: true,
	refresh_time: 20
});

class Globals extends Component {
}

export default Globals;



// WEBPACK FOOTER //
// ./src/Components/Miscelania/Globals.js